/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react';

export const IsAdminContext = createContext<string>('0');
export const UserProfileDataContext = createContext<any>({
  userProfileData: '',
  setUserProfileData: () => { },
});
export const UserDesignationDataContext = createContext<any>({
  userDesignationData: '',
  setDesignationData: () => { },
});
export const SkillListContext = createContext<any>([]);
export const ProjectListContext = createContext<any>([]);
export const AchievementListContext = createContext<any>([]);
export const StrengthPassionsListContext = createContext<any>([]);
export const PlanTypeContext = createContext<any>([]);
export const UserPlanDataContext = createContext<any>({});
export const UserSkillDataContext = createContext<any>({});
export const UserEducationDataContext = createContext<any>({});
export const UserProjectsDataContext = createContext<any>({});
export const UserAchievementsDataContext = createContext<any>({});
export const UserStrengthPassionsDataContext = createContext<any>({});
export const UserExperienceDataContext = createContext<any>({});
export const ProfilePictureContext = createContext<any>({
  userProfilePictureData: '',
  setUserProfilePictureData: () => { },
});
export const ResumeDataContext = createContext<any>([]);

export const NumberOfPlanContext = createContext<any>({
  numberOfPlans: 0,
  setNumberOfPlans: () => { },
});
export const NumberOfCoreSKillContext = createContext<any>({
  numberOfCoreSkills: 0,
  setNumberOfCoreSkills: () => { },
});
export const NumberOfSoftSkillontext = createContext<any>({
  numberOfSoftSkills: 0,
  setNumberOfSoftSkills: () => { },
});
export const NumberOfExperienceContext = createContext<any>({
  numberOfExperience: 0,
  setNumberOfExperience: () => { },
});
export const NumberOfEducationContext = createContext<any>({
  numberOfEducation: 0,
  setNumberOfEducation: () => { },
});
export const NumberOfProjectsContext = createContext<any>({
  numberOfProjects: 0,
  setNumberOfProjects: () => { },
});
export const NumberOfAchivementsContext = createContext<any>({
  numberOfAchievements: 0,
  setNumberOfAchievements: () => { },
});

export const NumberOfStrengthPassionsContext = createContext<any>({
  numberOfStrengthPassions: 0,
  setNumberOfStrengthPassions: () => { },
});

